"use client";

import Link from "next/link";
import { ChevronRight, Home } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Хлебные крошки" className="flex items-center gap-1.5 text-xs text-gray-700 dark:text-zinc-400 py-3 overflow-x-auto whitespace-nowrap">
      <Link
        href="/"
        className="flex items-center gap-1 text-gray-700 dark:text-zinc-400 hover:text-[#0a3d90] dark:hover:text-[#55a9ef] transition-colors"
      >
        <Home className="w-3.5 h-3.5" />
        <span>Главная</span>
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <div key={item.label} className="flex items-center gap-1.5">
            <ChevronRight className="w-3.5 h-3.5 text-gray-700 dark:text-zinc-400 shrink-0" />
            {isLast || !item.href ? (
              <span className="font-semibold text-gray-950 dark:text-white" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link
                href={item.href}
                className="hover:text-[#0a3d90] dark:hover:text-[#55a9ef] transition-colors"
              >
                {item.label}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}

